import { startFunnelSession, recordFunnelStep } from "@/utils/behaviorTracker";
import { safeTrack } from "./track";
import { PAGE_KEYS } from "./pageKeys";

export function trackRegisterEntryClick({ entry, pagePath, pageKey = PAGE_KEYS.HOME }) {
  startFunnelSession("register");
  recordFunnelStep(1);
  return safeTrack("register_entry_click", {
    page: pagePath || "",
    properties: { entry, page_key: pageKey },
  });
}

export function trackLoginEntryClick({ pagePath, pageKey = PAGE_KEYS.HOME }) {
  return safeTrack("button_click", {
    page: pagePath || "",
    properties: { button_id: "login_entry", feature: "login_entry", page_key: pageKey },
  });
}
